import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { AVAILABLE_THEMES } from 'src/app/core/helpers/ui/ui.constant';
import { Theme } from 'src/app/core/interfaces/ui/ui.interface';
import { changeTheme } from 'src/app/core/states/theme/theme.actions';
import { selectTheme } from 'src/app/core/states/theme/theme.selectors';

@Component({
  selector: 'shared-theme-toggle',
  templateUrl: './theme-toggle.component.html',
})
export class ThemeToggleComponent implements OnInit, OnDestroy {
  public isDark: boolean = false;

  private onDestroy$: Subject<boolean> = new Subject();

  constructor(private _store: Store) {}

  ngOnInit(): void {
    this._store
      .select(selectTheme)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((theme) => {
        this.isDark = theme === AVAILABLE_THEMES.DARK_ONLY;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
  }

  public toggleTheme(): void {
    const theme: Theme = this.isDark
      ? AVAILABLE_THEMES.LIGHT_ONLY
      : AVAILABLE_THEMES.DARK_ONLY;

    this._store.dispatch(changeTheme({ theme }));
  }
}
